import * as React from 'react';
import { createContainer } from 'unstated-next';
import { timingDefaultMs } from '../../constants';
const defaultArgs = {
    animate: true,
    disabled: false,
    initialIsExpanded: false,
    onChange: undefined,
};
function useState({ animate = defaultArgs.animate, disabled = defaultArgs.disabled, initialIsExpanded = defaultArgs.initialIsExpanded, onChange = defaultArgs.onChange, } = defaultArgs) {
    const [isExpanded, setIsExpanded] = React.useState(initialIsExpanded);
    const [showChildren, setShowChildren] = React.useState(isExpanded);
    const transitionTimer = React.useRef();
    const transitionDelay = animate ? timingDefaultMs : 0;
    React.useEffect(() => setIsExpanded(initialIsExpanded), [initialIsExpanded]);
    const toggleIsExpanded = () => setIsExpanded(currentlyIsOpen => !currentlyIsOpen);
    React.useEffect(() => {
        if (transitionTimer.current)
            clearTimeout(transitionTimer.current);
        if (isExpanded)
            setShowChildren(isExpanded);
        if (!isExpanded && showChildren) {
            transitionTimer.current = setTimeout(() => setShowChildren(false), transitionDelay);
        }
        return () => {
            if (transitionTimer.current)
                clearTimeout(transitionTimer.current);
        };
    }, [isExpanded]);
    return {
        animate,
        disabled,
        isExpanded,
        onChange,
        toggleIsExpanded,
        showChildren,
    };
}
export const StateContainer = createContainer(useState);
//# sourceMappingURL=StateContainer.js.map